<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <multiselect
        :value="selectedOptions"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        track-by="value"
        label="label"
        :placeholder="placeholder || 'Selecione...'"
        :disabled="isDisabled"
        :class="{'is-invalid-multi': isInvalid}"
        @input="handleChange"
        @close="validate"
      >
        <template slot="noResult">Nenhum resultado encontrado.</template>
        <template slot="noOptions">Nenhuma opção disponível.</template>
      </multiselect>
      <div
        v-if="isInvalid"
        class="invalid-feedback d-block"
      >
        <span>Campo obrigatório.</span>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Array],
      default: ''
    },
    classInput: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Selecione...'
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      default: false
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  computed: {
    selectedOptions () {
      if (!this.value) return []
      // Valor pode ser string CSV ou array
      let values = this.value
      if (typeof values === 'string') {
        try {
          const parsed = JSON.parse(values)
          if (Array.isArray(parsed)) {
            values = parsed
          } else {
            values = values.split(',').map(v => v.trim()).filter(Boolean)
          }
        } catch (e) {
          values = values.split(',').map(v => v.trim()).filter(Boolean)
        }
      }
      if (!Array.isArray(values)) values = [values]
      return this.options.filter(opt => values.includes(opt.value) || values.includes(opt.label))
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    handleChange (selected) {
      this.hasTouched = true
      // Emite como JSON array de valores
      const values = (selected || []).map(opt => opt.value || opt.label)
      this.$emit('input', JSON.stringify(values))

      if (this.isInvalid && values.length > 0) {
        this.isInvalid = false
      }
    },
    validate () {
      const shouldValidate = this.hasTouched || this.forceShowError
      const isEmpty = !this.value || this.value === '' || this.value === '[]'
      this.isInvalid = shouldValidate && this.isRequired && isEmpty
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>

<style>
.is-invalid-multi .multiselect__tags {
  border-color: #dc3545 !important;
}
</style>
